import React, {useEffect, useRef} from "react";
import CambioIdioma from "../scripts/CambioIdioma";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function MetodoBusquedaCole(){
    const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
    const todas = useRef(null);
    const cualquiera = useRef(null);
    const frase = useRef(null);
    // const boton = useRef(document.getElementById("search"));

    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en."
    }
    const handleSelect1 = () => {
        _updateFiltros({metodoBusqueda:1});
        _updateFiltros({paginaFin:10});
        $("#search").trigger("click");
    }
    const handleSelect2 = () => {
        _updateFiltros({metodoBusqueda:2});
        _updateFiltros({paginaFin:10});
        $("#search").trigger("click");
    }
    const handleSelect3 = () => {
        _updateFiltros({metodoBusqueda:3});
        _updateFiltros({paginaFin:10});
        $("#search").trigger("click");
    }
    useEffect(() => {
        if (todas !== null){
            CambioIdioma.valida(var_ingles, todas);
        }
        if (cualquiera !== null){
            CambioIdioma.valida(var_ingles, cualquiera);
        } 
        if (frase !== null){
            CambioIdioma.valida(var_ingles, frase);
        }
        _updateFiltros({metodoBusqueda:1});
    },[]);
   return(
    <div className="row" id="metodoBusqueda" style={{paddingLeft:"5px"}}>
        <div className="col-md-8 col-xs-12 col-sm-12 slp-tbl_buscador slp-marginTB" id="todoroworden">
                <div className="slp-tbl-row_buscador">
                    <div className="slp-tbl-col_buscador">
                        <fieldset>
                            <legend></legend>
                                <div className="row" style={{paddingLeft: "15px"}}>
                                    <div className="tamChec form-check form-check-inline col-sm-12 col-md-12 col-lg-3">
                                        <label className="form-check-label" htmlFor="radio01">
                                            <input type="radio" onChange={handleSelect1} value="True" className="form-check-input"  id="radio01" name="option" defaultChecked={true}/>
                                            <label id="todas" htmlFor="radio01" ref={todas}>Todas las palabras</label>
                                        </label>
                                    </div>
                                    <div className="tamChec form-check form-check-inline col-sm-12 col-md-12 col-lg-3">
                                        <label className="form-check-label" htmlFor="radio02">
                                            <input type="radio" onChange={handleSelect2} value="False" className="form-check-input" id="radio02" name="option" />
                                            <label id="cualquiera"  htmlFor="radio02" ref={cualquiera}>Cualquier palabra</label>
                                        </label>
                                    </div>
                                    <div className="tamChec form-check form-check-inline col-sm-12 col-md-12 col-lg-3">
                                            <label className="form-check-label" htmlFor="radio03">
                                                <input type="radio" onChange={handleSelect3} value="False" className="form-check-input"  id="radio03" name="option" />
                                                <label id="frase"  htmlFor="radio03" ref={frase}>Frase completa</label> 
                                            </label>
                                    </div>
                                </div>
                        </fieldset>
                    </div> 
                </div> 
        </div> 
    </div>              
    )
}

